import { msg } from "../locales/translate";
import { Req } from "badmfck-signal";
import { GD } from "../GD";

const BALANCER_URL: string = "https://cascade.impaya.com/api/v1/";

export class BalancerDispatcher {
	static REQ_EMULATE_REQUEST = new Req<IEmulateTransferData, IAPIResponse<any>>(undefined, "BALANCER.REQ_EMULATE_REQUEST");

	static REQ_CHECK_REQUEST = new Req<ICheckRecieverData, IAPIResponse<IBalancerCheckEntry[]>>(undefined, "BALANCER.REQ_CHECK_REQUEST");

	static REQ_STAT = new Req<IBalancerStatRequest, IAPIResponse<IBalancerStatData>>(undefined, "BALANCER.REQ_STAT");

	static REQ_STAT_MERCHANT = new Req<MerchantStatRequest, IAPIResponse<IMerchantStat | undefined>>(undefined, "BALANCER.REQ_STAT_MERCHANT");

	static REQ_STAT_CLIENT = new Req<ClientStatRequest, IAPIResponse<IClientStat | undefined>>(undefined, "BALANCER.REQ_STAT_CLIENT");

	static REQ_ACUIRERS = new Req<IBalancerStatRequest, IAPIResponse<IBalancerAcquirerStat[]>>(undefined, "BALANCER.REQ_ACUIRERS");

	static REQ_COUNTRIES = new Req<IBalancerStatRequest, IAPIResponse<IBalancerCountryStat[]>>(undefined, "BALANCER.REQ_COUNTRIES");

	static REQ_STATUSES = new Req<Record<string, unknown>, IAPIResponse<{ statuses: IStatus[]; normalized: IStatusNormilized[] }>>(
		undefined,
		"BALANCER.REQ_STATUSES"
	);

	static REQ_STATUS_MAP = new Req<{ status: IStatus; normalized: IStatusNormilized }, IAPIResponse<any>>(undefined, "BALANCER.REQ_STATUS_MAP");

	static REQ_STATUS_ADD = new Req<{ name: string; weight: number; gate_id: number }, IAPIResponse<any>>(undefined, "BALANCER.REQ_STATUS_ADD");
}

export class BalancerService {
	static ssid = "7cf3ed1c12fdb3a57e3158923f472d5c71af9b51b4809f71ff07d449bed871a0";

	constructor() {
		BalancerDispatcher.REQ_EMULATE_REQUEST.listener = this.emulateRequest;

		BalancerDispatcher.REQ_CHECK_REQUEST.listener = this.checkRequest;

		//!TODO: cache, debounce;
		BalancerDispatcher.REQ_STAT.listener = this.getStat;
		//!TODO: cache, debounce;
		BalancerDispatcher.REQ_ACUIRERS.listener = this.getAcquirersStat;
		//!TODO: cache, debounce;
		BalancerDispatcher.REQ_COUNTRIES.listener = this.getCounriesStat;
		//!TODO: cache, debounce;
		BalancerDispatcher.REQ_STATUSES.listener = this.getStatuses;

		BalancerDispatcher.REQ_STATUS_MAP.listener = this.setStatus;
		BalancerDispatcher.REQ_STATUS_ADD.listener = this.addStatus;

		//!TODO: cache, debounce;
		BalancerDispatcher.REQ_STAT_MERCHANT.listener = this.getStatMerchant;

		//!TODO: cache, debounce;
		BalancerDispatcher.REQ_STAT_CLIENT.listener = this.getStatClient;
	}

	getStatClient = async (req: ClientStatRequest): Promise<IAPIResponse<IClientStat | undefined>> => {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		//!TODO: get only the one merchant stat;
		const res = await GD.REQ_API.request({
			url: BALANCER_URL + "balancer/client/overview",
			method: "" as IAPIMethod,
			data: {
				yyyymm: req.yyyymm,
				currency: req.currency,
				clientID: req.clientId,
			},
			headers: { Authorization: "Basic " + BalancerService.ssid },
		});

		return res;
	};

	getStatMerchant = async (req: MerchantStatRequest): Promise<IAPIResponse<IMerchantStat | undefined>> => {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		//!TODO: get only the one merchant stat;
		const res = await GD.REQ_API.request({
			url: BALANCER_URL + "balancer/merchants",
			method: "" as IAPIMethod,
			data: {
				yyyymm: req.yyyymm,
				currency: req.currency,
			},
			headers: { Authorization: "Basic " + BalancerService.ssid },
		});

		if (res.error) {
			return res;
		}

		const merchantId: number = req.merchantId;

		const allMerchantsStat: IMerchantStat[] = res.data;
		const merchantStat: IMerchantStat | undefined = allMerchantsStat.find(m => m.id === merchantId);
		if (!merchantStat) {
			return {
				error: {
					code: -1,
					message: msg("statDataForTheMerchantNotFound"),
				},
			};
		}

		return { data: merchantStat };
	};

	addStatus = async (req: { name: string; weight: number; gate_id: number }): Promise<IAPIResponse<any>> => {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		const res = await GD.REQ_API.request({
			url: BALANCER_URL + "statuses/normalized/add",
			method: "" as IAPIMethod,
			data: req,
			headers: { Authorization: "Basic " + BalancerService.ssid },
		});

		return res;
	};

	setStatus = async (req: { status: IStatus; normalized: IStatusNormilized }): Promise<IAPIResponse<any>> => {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		const res = await GD.REQ_API.request({
			url: BALANCER_URL + "statuses/link",
			method: "" as IAPIMethod,
			data: {
				id: req.status.id,
				map_id: req.normalized.id,
			},
			headers: { Authorization: "Basic " + BalancerService.ssid },
		});

		return res;
	};

	getStatuses = async (req: any): Promise<IAPIResponse<{ statuses: IStatus[]; normalized: IStatusNormilized[] }>> => {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		const res = await GD.REQ_API.request({
			url: BALANCER_URL + "statuses/get",
			method: "" as IAPIMethod,
			data: req,
			headers: { Authorization: "Basic " + BalancerService.ssid },
		});

		return res;
	};

	getCounriesStat = async (req: IBalancerStatRequest): Promise<IAPIResponse<IBalancerCountryStat[]>> => {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		const res = await GD.REQ_API.request({
			url: BALANCER_URL + "balancer/countries",
			method: "" as IAPIMethod,
			data: req,
			headers: { Authorization: "Basic " + BalancerService.ssid },
		});

		return res;
	};

	getAcquirersStat = async (req: IBalancerStatRequest): Promise<IAPIResponse<IBalancerAcquirerStat[]>> => {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		const res = await GD.REQ_API.request({
			url: BALANCER_URL + "balancer/acquirers",
			method: "" as IAPIMethod,
			data: req,
			headers: { Authorization: "Basic " + BalancerService.ssid },
		});

		return res;
	};

	//!TODO: response type
	emulateRequest = async (req: IEmulateTransferData): Promise<IAPIResponse<any>> => {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		const data: IStrategyRequest = {
			amount: req.amount,
			currency: req.currency,
			email: req.email,
			pan: req.card,
		};
		const res = await GD.REQ_API.request({
			url: BALANCER_URL + "strategy/get",
			method: "" as IAPIMethod,
			data: data,
			headers: { Authorization: "Basic " + BalancerService.ssid },
		});

		return res;
	};

	checkRequest = async (req: ICheckRecieverData): Promise<IAPIResponse<IBalancerCheckEntry[]>> => {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		const res = await GD.REQ_API.request({
			url: BALANCER_URL + "balancer/check",
			method: "" as IAPIMethod,
			data: { value: req.card },
			headers: { Authorization: "Basic " + BalancerService.ssid },
		});

		return res;
	};

	getStat = async (req: IBalancerStatRequest): Promise<IAPIResponse<IBalancerStatData>> => {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		req.offset = 0;

		const res = await GD.REQ_API.request({
			//url: BALANCER_URL + "overall/trx/monthly",
			method: "overview/get" as IAPIMethod,
			data: { ...req },
			headers: { Authorization: "Basic " + BalancerService.ssid },
		});

		if (res.error) {
			return res;
		}

		// const data: IBalancerStatData = res.data;
		return res;

		// const turnoverDay: IBalancerStat = {
		// 	all: 0,
		// 	success: 0,
		// 	fail: 0,
		// };

		// const transactionsDay: IBalancerStat = {
		// 	all: 0,
		// 	success: 0,
		// 	fail: 0,
		// };

		// let lastDay: string = "";
		// if (data && data.hours && data.hours.length > 0) {
		// 	lastDay = Math.max(...data.hours.map(d => Number(d.yyyymmdd))).toString();
		// }

		// if (data && data.hours && data.hours.length > 0) {
		// 	if (lastDay) {
		// 		const lastDaysItems = data.hours.filter(i => i.yyyymmdd === lastDay);
		// 		if (lastDaysItems) {
		// 			turnoverDay.fail = lastDaysItems.reduce((sum, current) => sum + current.failed_turnover / 100, 0);
		// 			turnoverDay.success = lastDaysItems.reduce((sum, current) => sum + current.success_turnover / 100, 0);
		// 			turnoverDay.all = turnoverDay.fail + turnoverDay.success;

		// 			transactionsDay.fail = lastDaysItems.reduce((sum, current) => sum + current.failed_trx_count, 0);
		// 			transactionsDay.success = lastDaysItems.reduce((sum, current) => sum + current.success_trx_count, 0);
		// 			transactionsDay.all = transactionsDay.fail + transactionsDay.success;
		// 		}
		// 	}
		// }

		// const turnoverMonth: IBalancerStat = {
		// 	all: data.monthly_failed / 100 + data.monthly_success / 100,
		// 	success: data.monthly_success / 100,
		// 	fail: data.monthly_failed / 100,
		// };

		// const transactionsMonth: IBalancerStat = {
		// 	all: data.monthly_failed_trx + data.monthly_success_trx,
		// 	success: data.monthly_success_trx,
		// 	fail: data.monthly_failed_trx,
		// };

		// //const selectedDate:Date = YYYYMMDDHH_toDate(parseInt(lastDay));

		// const m = lastDay.match(/(....)(..)(..)/);
		// const selectedDate = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date();

		// //const selectedDateLocal = selectedDate.toLocaleDateString();
		// const year: string = lastDay.length > 7 ? lastDay.slice(0, 4) : "";
		// const month: string = lastDay.length > 7 ? lastDay.slice(4, 6) : "";
		// const dayToday: string = lastDay.length > 7 ? lastDay.slice(6, 8) : "";

		// const monthTransactions: IDateEntry[] = [];

		// const daysArray = [...Array(this.daysInMonth(selectedDate)).keys()].map(foo => (foo + 1).toString().padStart(2, "0"));

		// const yearToday: number = parseInt(year, 10);
		// const monthToday = String(parseInt(month, 10)).padStart(2, "0");
		// for (let index = 0; index < daysArray.length; index++) {
		// 	const element = daysArray[index];

		// 	monthTransactions.push({
		// 		title: Number(element).toString(),
		// 		date: yearToday.toString() + monthToday.toString() + element.toString(),
		// 		value: [],
		// 		legendValue: undefined,
		// 	});
		// }

		// for (let index = 0; index < monthTransactions.length; index++) {
		// 	const element = monthTransactions[index];

		// 	const existValues = data.hours.filter(d => {
		// 		return d.yyyymmdd === element.date;
		// 	});

		// 	if (existValues.length > 0) {
		// 		const success = existValues.reduce((sum, current) => sum + current.success_trx_count, 0);
		// 		const fail = existValues.reduce((sum, current) => sum + current.failed_trx_count, 0);

		// 		element.value = [success, fail];
		// 	}

		// 	const m = lastDay.match(/(....)(..)(..)/);
		// 	const itemDate = m ? new Date(yearToday, parseInt(month, 10), parseInt(element.title, 10)) : new Date();
		// 	element.legendValue = itemDate.toLocaleDateString();
		// }

		// const dayTransactions: { date: string; values: IValuable[] } = {
		// 	date: dayToday + "." + month + "." + year,
		// 	values: [],
		// };

		// const hoursArray = [...Array(24).keys()].map(foo => foo.toString().padStart(2, "0"));

		// for (let index = 0; index < hoursArray.length; index++) {
		// 	const element = hoursArray[index];
		// 	const targetTime = year + month + dayToday + element.padStart(2, "0");

		// 	const search = data.hours.find(f => f.yyyymmddhh.toString() === targetTime);

		// 	const date: Date | undefined = search ? YYYYMMDDHH_toDate(search.yyyymmddhh) : undefined;
		// 	if (date) {
		// 		date.setHours(date.getHours() + 1);
		// 	}

		// 	dayTransactions.values.push({
		// 		title: (Number(element) + 1).toString().padStart(2, "0"),
		// 		legendValue: date ? date.toLocaleDateString() + " " + date.toLocaleTimeString() : undefined,
		// 		date: targetTime,
		// 		value: search ? [search.success_trx_count, search.failed_trx_count] : [0, 0],
		// 	} as IValuable);
		// }

		// if (!data.currency && data.hours && data.hours.length > 0 && data.hours[0] && data.hours[0].currency) {
		// 	data.currency = data.hours[0].currency;
		// }

		// data.stat = {
		// 	day: { turnover: turnoverDay, transactions: transactionsDay },
		// 	month: {
		// 		turnover: turnoverMonth,
		// 		transactions: transactionsMonth,
		// 	},
		// 	monthTransactions: monthTransactions,
		// 	dayTransactions: dayTransactions,
		// };
		return res;
	};

	daysInMonth(anyDateInMonth: Date) {
		return new Date(anyDateInMonth.getFullYear(), anyDateInMonth.getMonth() + 1, 0).getDate();
	}
}
